'use client'

import { useMemo, type JSX } from 'react'

import { ConfigurationState } from '@marketplace-web/catalog/catalog-data'

import Context from './CatalogConfigurationContext'

type CatalogConfigurationProviderProps = {
  children: JSX.Element
  configuration: ConfigurationState
}

const CatalogConfigurationProvider = ({
  children,
  configuration,
}: CatalogConfigurationProviderProps) => {
  const value = useMemo(() => configuration, [configuration])

  return <Context.Provider value={value}>{children}</Context.Provider>
}

export default CatalogConfigurationProvider
